<div class="p-4 new-theme-typography">

    <div>
        <ng-container *ngIf="(integration$ | async) as integration">
            <mat-card appearance="outlined"
                      class="mb-4"
                      *appLet="statusMap[integration.status] as statusConfig">
                <div class="column-grid gap-4 justify-start py-2">
                    <span>Connection:</span>
                    <mat-chip class="!rounded-full !h-6 {{ statusConfig?.color }}">{{ statusConfig.label }}</mat-chip>
                    <mat-divider [vertical]="true"></mat-divider>
                    <span >Connected:</span>
                    <span>{{ integration.modified | date }}</span>
                </div>
            </mat-card>
        </ng-container>
    </div>

    <div appDynamicScreenHeight
         [dshdConfig]="{offset: 16}">
        <mat-card class="max-h-full overflow-hidden !p-0" appearance="outlined">
            <mat-card-header>
                <mat-card-title>Event Log</mat-card-title>
            </mat-card-header>
            <div class="pb-4 max-h-full overflow-hidden grid grid-rows-[1fr_auto_auto]">
                <mat-table class="overflow-y-scroll" [dataSource]="activitiesDataSource$ | async">
                    <mat-header-row *matHeaderRowDef="columns; sticky: true;"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: columns;"></mat-row>

                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                        <mat-cell *matCellDef="let activity"> {{ activity.action }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="dealId">
                        <mat-header-cell *matHeaderCellDef> Deal ID </mat-header-cell>
                        <mat-cell *matCellDef="let activity"> {{ activity.dealId }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="transactionId">
                        <mat-header-cell *matHeaderCellDef> Ext. Transaction. ID </mat-header-cell>
                        <mat-cell *matCellDef="let activity"> {{ activity.externalTransactionId }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
                        <mat-cell *matCellDef="let activity"> {{ activity.errored ? 'Failed' : 'Success' }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="timestamp">
                        <mat-header-cell *matHeaderCellDef> Date/Time </mat-header-cell>
                        <mat-cell *matCellDef="let activity"> {{ activity.created | date: 'MM/dd/YY \'at\' h:mma' }} </mat-cell>
                    </ng-container>

                </mat-table>

                <div class="relative w-full">
                    <mat-divider></mat-divider>
                </div>

                <lendio-paginator #paginator
                                  (page)="handlePaginationEvent($event)"
                                  [length]="total$ | async"
                                  [pageSize]="pageSize$ | async"
                                  [pageSizeOptions]="pageSizeOptions$ | async"
                                  [pageIndex]="(pageIndex$ | async) - 1"
                                  [showFirstLastButtons]="true">
                </lendio-paginator>
            </div>

        </mat-card>
    </div>

</div>
